import Phaser from 'phaser';
import { GameState, STAT_CHANGED_EVENT } from '@/engine/GameState';
import { SCENE_KEYS } from '@/engine/nav';

const ALTO_HUD = 100;
const COLOR_FONDO_HUD = 0x000000;
const OPACIDAD_FONDO_HUD = 0.55;

/**
 * HUD superior persistente y reactivo: ✊ respeto · 💶 dinero · ❤️ salud.
 * Se lanza como escena en paralelo (scene.launch) por encima de HubScene y
 * PlaceholderScene, y se mantiene viva mientras el jugador navega entre
 * ellas. Escucha STAT_CHANGED_EVENT del GameState para refrescarse sin que
 * ninguna escena de contenido tenga que empujarle datos a mano.
 */
export class HudScene extends Phaser.Scene {
  private textoRespeto!: Phaser.GameObjects.Text;
  private textoDinero!: Phaser.GameObjects.Text;
  private textoRacha!: Phaser.GameObjects.Text;
  private textoSalud!: Phaser.GameObjects.Text;

  constructor() {
    super(SCENE_KEYS.HUD);
  }

  create(): void {
    const { width } = this.scale;

    const fondo = this.add.graphics();
    fondo.fillStyle(COLOR_FONDO_HUD, OPACIDAD_FONDO_HUD);
    fondo.fillRect(0, 0, width, ALTO_HUD);

    const estiloTexto: Phaser.Types.GameObjects.Text.TextStyle = {
      fontFamily: 'system-ui, sans-serif',
      fontSize: '26px',
      color: '#ffffff',
    };

    const y = ALTO_HUD / 2;
    // El indicador de racha vive pegado al borde derecho (siempre), y la
    // salud se recoloca un pelín a la izquierda para no chocar cuando ambos
    // están visibles. Cuando no hay racha la salud vuelve a su sitio. El
    // ancho reservado para la racha se calcula en `refrescar` para que la
    // salud se reposicione correctamente cuando aparezca.
    const MARGEN_DERECHO = 24;
    this.textoRespeto = this.add.text(MARGEN_DERECHO, y, '', estiloTexto).setOrigin(0, 0.5);
    this.textoDinero = this.add.text(width / 2, y, '', estiloTexto).setOrigin(0.5);
    this.textoRacha = this.add.text(width - MARGEN_DERECHO, y, '', estiloTexto).setOrigin(1, 0.5);
    this.textoSalud = this.add.text(width - MARGEN_DERECHO, y, '', estiloTexto).setOrigin(1, 0.5);

    this.refrescar();

    GameState.on(STAT_CHANGED_EVENT, this.refrescar, this);
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
      GameState.off(STAT_CHANGED_EVENT, this.refrescar, this);
    });
    this.events.once(Phaser.Scenes.Events.DESTROY, () => {
      GameState.off(STAT_CHANGED_EVENT, this.refrescar, this);
    });
  }

  private refrescar = (): void => {
    const snap = GameState.getSnapshot();
    const { width } = this.scale;
    const MARGEN_DERECHO = 24;
    const RACHA_ANCHO_PIX = 120;

    this.textoRespeto.setText(`✊ ${snap.respeto}`);
    this.textoDinero.setText(`💶 ${snap.dinero}`);
    this.textoSalud.setText(`❤️ ${snap.salud}`);

    // La racha solo se muestra si > 0. Si está activa, desplazamos la salud
    // un poco a la izquierda para que no se solape con el icono de fuego.
    const rachaDias = snap.racha.diasConsecutivos;
    if (rachaDias > 0) {
      this.textoRacha.setVisible(true);
      this.textoRacha.setText(`🔥 ${rachaDias}`);
      this.textoSalud.setX(width - MARGEN_DERECHO - RACHA_ANCHO_PIX);
    } else {
      this.textoRacha.setVisible(false);
      this.textoRacha.setText('');
      this.textoSalud.setX(width - MARGEN_DERECHO);
    }
  };
}
